import { render } from "./CopyProductsModal.vue?vue&type=template&id=c62d3b5a"
import script from "./CopyProductsModal.vue?vue&type=script&lang=js"
export * from "./CopyProductsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__